import { Table } from "antd";
import React from "react";
import { useQuery } from "react-query";
import { Curl } from "./Jarvis";

export default function ETable({
  name,
  rowKey = "id",
  uri,
  columns,
  size = "small",
  props,
  query,
  setLoading,
  forceUpdate,
}) {
  const [pagination, setPagination] = React.useState({ current: 1 });

  const { data, isFetching, refetch } = useQuery(name, () => {
    let delimiter = "?";
    // console.log("query", typeof query);
    if (
      query === undefined ||
      (typeof query === "string" && query.length === 0)
    ) {
      query = "";
    } else {
      delimiter = "&";
    }
    return Curl.get(
      `${uri}${query}${delimiter}page=${pagination.current}`
    ).then((data) => {
      data.payload?.pagination && setPagination(data.payload.pagination);
      return data.payload.data;
    });
  });

  const onTableChange = (pagination) => {
    setPagination(pagination);
  };

  React.useEffect(() => {
    setPagination({ current: 1 });
  }, [query]);
  React.useEffect(() => {
    refetch();
  }, [refetch, query, pagination.current, forceUpdate]);

  if (isFetching) {
    if (setLoading) {
      setLoading(true);
    }
  }

  React.useEffect(() => {
    if (setLoading && isFetching === false) {
      setLoading(false);
    }
  }, [isFetching]);

  return (
    <Table
      rowKey={rowKey}
      loading={isFetching}
      pagination={{
        ...pagination,
        position: ["bottomCenter"],
        showTotal: (total, range) => {
          if (total <= 1) {
            return `${total} Record`;
          }
          return `${total} Records`;
        },
        showSizeChanger: false,
      }}
      columns={columns}
      dataSource={data}
      size={size}
      // bordered
      onChange={onTableChange}
      {...props}
    />
  );
}
